type NavListProps = {
  links: {
    value: string;
    href: string;
    icon?: React.ComponentType<any>;
  }[];
  asLink?: "a" | React.ComponentType<any>;
  onClick?: () => void;
};

export const NavList = ({ links, asLink = "a", onClick }: NavListProps) => {
  const LinkComponent = asLink;

  return (
    <ul className="list-style-none" role="list">
      {links?.map((link) => {
        const IconComponent = link?.icon;
        return (
          <li key={link.value} className="py-x20 py-x8 border-bottom">
            <LinkComponent
              href={link.href}
              className="w-full underline text-decoration-none text-primary fs-5 md-fs-4 fw-regular base-row align-items-center gap-x8"
              onClick={() => {
                onClick?.();
              }}
            >
              {IconComponent ? (
                <IconComponent color="primary" width={32} height={32} />
              ) : null}
              {link.value}
            </LinkComponent>
          </li>
        );
      })}
    </ul>
  );
};
